import { BaseDB, Singleton } from '@pawgame/game-library';
import { getConfig } from '../../supports/Config';
export class CodeDB extends BaseDB {
    static getInst() {
        return Singleton.get(CodeDB);
    }
    constructor() {
        super(getConfig('code'), 'code');
    }
}
//# sourceMappingURL=CodeDB.js.map